const STORAGE_KEY = "bytebite.dashboard.restaurantId";

export function readStoredRestaurantId(fallback: string | null): string | null {
  if (typeof window === "undefined") {
    return fallback;
  }
  return window.localStorage.getItem(STORAGE_KEY) ?? fallback;
}

export function storeRestaurantId(restaurantId: string): void {
  window.localStorage.setItem(STORAGE_KEY, restaurantId);
}
